import React from "react";
import PropTypes from "prop-types";

export const UserFallbackIcon = ({ width = 120, height = 120 }) => {
  return (
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="96" height="96" fill="#F5F5F5" />
      <path
        d="M62.9663 34.185C62.9663 25.9219 56.2388 19.2188 48 19.2188C39.7613 19.2188 33.0337 25.9219 33.0337 34.185C33.0337 42.4236 39.7613 49.1268 48 49.1268C56.2388 49.1268 62.9663 42.4237 62.9663 34.185ZM18.8719 82.4719V91.125C18.8719 93.148 20.5049 94.7812 22.5281 94.7812H73.4719C75.4951 94.7812 77.1282 93.148 77.1282 91.125V82.4719C77.1282 66.4087 64.0632 53.3438 48 53.3438C31.9368 53.3438 18.8719 66.4087 18.8719 82.4719Z"
        fill="#E5E6E8"
      />
    </svg>
  );
};

UserFallbackIcon.propTypes = {
  width: PropTypes.object,
  height: PropTypes.object,
};
